import { useContext } from 'react';

import { OfferContext } from '@App/contexts/Offer';
import { ApplicationContext } from '@src/app/contexts/Application';
import useConversionTracking from '@src/app/hooks/useConversionTracking';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import FinaliseView from '@src/ui/views/offer/FinaliseView';

const Finalise = () => {
    const { applicationEmail } = useContext(ApplicationContext);
    const { loading } = useContext(OfferContext);

    useConversionTracking(applicationEmail, 385995);

    return (
        <EligibilityLayout loading={loading} showTrustbarV2>
            <FinaliseView />
        </EligibilityLayout>
    );
};

export default Finalise;
